interface ContextoRadarProps {
  explicacao?: string | null;
  fatoresFavoraveis?: string[];
  fatoresContrarios?: string[];
  pendencias?: string[];
  prazo?: string | null;
}

export function ContextoRadar({ explicacao, fatoresFavoraveis, fatoresContrarios, pendencias, prazo }: ContextoRadarProps) {
  const hasStructuredContext = Boolean(explicacao || fatoresFavoraveis?.length || fatoresContrarios?.length || pendencias?.length);

  return (
    <section className="mt-3 rounded-lg border border-ds-border bg-ds-surface2 p-3 text-sm text-ds-text-secondary" aria-label="Contexto para decidir">
      <h4 className="font-semibold text-ds-text-primary">O que conferir antes de decidir</h4>
      {explicacao && <p className="mt-1">{explicacao}</p>}
      {!!fatoresFavoraveis?.length && <p className="mt-2"><strong className="text-ds-text-primary">O que favorece:</strong> {fatoresFavoraveis.join(', ')}.</p>}
      {!!fatoresContrarios?.length && <p className="mt-1"><strong className="text-ds-text-primary">Pontos de atenção:</strong> {fatoresContrarios.join(', ')}.</p>}
      {!!pendencias?.length && <p className="mt-1"><strong className="text-ds-text-primary">Ainda falta analisar:</strong> {pendencias.join(', ')}.</p>}
      {!hasStructuredContext && <p className="mt-1">Ainda não há mais contexto estruturado para este processo. Use o edital oficial para confirmar objeto, prazo{prazo ? ` (${prazo})` : ''} e exigências de habilitação.</p>}
      {hasStructuredContext && <p className="mt-2">Antes de confirmar, valide no edital o objeto, o prazo e os documentos exigidos.</p>}
    </section>
  );
}
